import http from '../auth/httpService';

const apiEndpoint1 = '/projects';
const apiEndpoint2 = '/plannedBudget';
const apiEndpoint3 = '/executedBudget';

export function getProjectPlannedBudget(projectSlug) {
  return http.get(`${apiEndpoint1}/${projectSlug}${apiEndpoint2}`);
}

export function getProjectExecutedBudget(projectSlug) {
  return http.get(`${apiEndpoint1}/${projectSlug}${apiEndpoint3}`);
}
